module.exports = __webpack_public_path__ + "static/img/2.6ca15c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/5/sp/2.png
// module id = rNAZ
// module chunks = 0